import { render } from "./Tratamientos.vue?vue&type=template&id=6572c9a7&scoped=true&ts=true"
import script from "./Tratamientos.vue?vue&type=script&lang=ts"
export * from "./Tratamientos.vue?vue&type=script&lang=ts"

import "./Tratamientos.vue?vue&type=style&index=0&id=6572c9a7&lang=scss&scoped=true"

import exportComponent from "/home/rdimicheleb/Repos/AMII/apps/app-paciente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6572c9a7"]])

export default __exports__